<avano-tabs [(selectedId)]="currentTabIndex" [tabsLoaded]="tabsLoaded$ | async">
  <avano-tab-item [label]="translationKeys.productComponent.html.products | translate" leftIcon="icon-content-product" tabId="FIXED">
    <ng-template avanoTabBody>
      <scip-products-table-tab (openProductTab)="openProductDetails($event)" [loadingInfo]="loadingInfo$ | async"></scip-products-table-tab>
    </ng-template>
  </avano-tab-item>
  <ng-container *ngIf="productTabs$ | async">
    <avano-tab-item
      [tabId]="productTab.id"
      *ngFor="let productTab of productTabs; let i = index"
      [closable]="true"
      (closed)="onCloseTriggered($event)"
      [isLoading]="!productTab?.name"
      [isUnsaved]="productTab?.isUnsaved"
      [label]="productTab.name"
    >
  <ng-template avanoTabBody>
    <scip-product-details
        #details
        [productId]="productTab.id"
        (saveTriggered)="saveProductTab(productTab.id)"
        (cancelRequested)="cancelProductTab(productTab.id)"
        (uploadDossierTriggered)="handleDossierUploadInTab()"
      >
      </scip-product-details>
  </ng-template>
  </avano-tab-item>
  </ng-container>
</avano-tabs>
